import type { RouteRecordRaw } from 'vue-router';

import { routes as auctionsRoutes } from '@/features/auctions';
import { routes as configureRoutes } from '@/features/configure';
import { routes as auditRoutes } from '@/features/audit';
import { routes as distributeRoutes } from '@/features/distribute';
import { routes as adminCatalogRoutes } from '@/features/admin-catalog';
import { routes as runLiveRoutes } from '@/features/run-live';
import { routes as categoriesRoutes } from '@/features/categories';
import { routes as settingsRoutes } from '@/features/settings';
import { routes as reconcileReportRoutes } from '@/features/reconcile-report';
import { communicationsRoutes as communicationsFeatureRoutes } from '@/features/communications';
import { routes as settlementRoutes } from '@/features/settlement';
import { routes as supervisorRoutes } from '@/features/supervisor';

export interface FeatureModule {
  name: string;
  routes: RouteRecordRaw[];
}

const features: FeatureModule[] = [
  { name: 'auctions', routes: auctionsRoutes },
  { name: 'configure', routes: configureRoutes },
  { name: 'audit', routes: auditRoutes },
  { name: 'distribute', routes: distributeRoutes },
  { name: 'admin-catalog', routes: adminCatalogRoutes },
  { name: 'run-live', routes: runLiveRoutes },
  { name: 'categories', routes: categoriesRoutes },
  { name: 'settings', routes: settingsRoutes },
  { name: 'reconcile-report', routes: reconcileReportRoutes },
  { name: 'communications', routes: communicationsFeatureRoutes },
  { name: 'settlement', routes: settlementRoutes },
  { name: 'supervisor', routes: supervisorRoutes },
  // fe-008: dashboard A0.1 + auction-overview A0.2 + audit log A-S1
  // fe-009: configure wizard A1.1–A1.6 + publish validation
  // fe-010: catalog A2.1–A2.4
  // fe-011: categories A2.6 + settings A0.3
  // fe-012: distribute A3.1–A3.3
  // fe-013: run-live A4.1–A4.5
];

export function registeredFeatures(): readonly FeatureModule[] {
  return features;
}

export function aggregateFeatureRoutes(): RouteRecordRaw[] {
  return features.flatMap(f => f.routes);
}
